import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'

export default function createBarChart (
  data,
  element,
  measure,
  titleString,
  xAxis,
  yAxis
) {
  let chart = am4core.create(element, am4charts.XYChart)
  chart.responsive.enabled = false

  chart.data = data

  // Create Y axis
  var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
  categoryAxis.dataFields.category = yAxis ? yAxis.key : 'label'
  categoryAxis.renderer.minGridDistance = 10
  categoryAxis.renderer.labels.each(f => {
    f.hideOversized = false
  })

  // create X axis
  var valueAxis = chart.xAxes.push(new am4charts.ValueAxis())
  valueAxis.min = 0
  if (measure === 'percent') {
    valueAxis.max = 100
  }
  valueAxis.strictMinMax = true
  // what do we need to base this on chart width instead of pixels? chart.width/5 or whatevs doesn't work.
  valueAxis.renderer.minGridDistance = 80

  // create series
  if (xAxis) {
    xAxis.series.forEach(s => {
      createSeries(s)
    })
  } else {
    createSeries({})
  }

  function createSeries (series) {
    var chartSeries = chart.series.push(new am4charts.ColumnSeries())
    chartSeries.stacked = series.stacked ? series.stacked : false
    chartSeries.name = series.xAxisKey ? series.xAxisKey : null
    chartSeries.dataFields.categoryY = series.yAxisKey
      ? series.yAxisKey
      : 'label'

    chartSeries.dataFields.valueX = series.xAxisKey ? series.xAxisKey : 'value'

    if (series.xAxisKey) {
      // eslint-disable-next-line
      chartSeries.columns.template.tooltipText =
        '{categoryY} {name}: [bold]{valueX}'
    } else {
      chartSeries.columns.template.tooltipText =
        '{categoryY} {name}: [bold]{valueX}'
    }

    chartSeries.columns.template.fillOpacity = 1
    // this works in codepen not here- overridden where?
    chartSeries.columns.template.width = 2

    // chartSeries.columns.template.events.on('hit', ev => series.clickFunc(ev))
    var columnTemplate = chartSeries.columns.template
    columnTemplate.strokeWidth = 0
    columnTemplate.strokeOpacity = 0

    var valueLabel = chartSeries.columns.template.createChild(am4core.Label)
    valueLabel.adapter.add('text', function (value, target) {
      if (target.dataItem.dataContext.valueSuppressed) {
        return 'Suppressed'
      }
      return value
    })
    // valueLabel.fontSize = 15
    valueLabel.valign = 'middle'
    valueLabel.dx = 5
    return chartSeries
  }
  categoryAxis.renderer.cellStartLocation = 0.12
  categoryAxis.renderer.cellEndLocation = 0.87

  var topContainer = chart.chartContainer.createChild(am4core.Container)
  topContainer.layout = 'absolute'
  topContainer.toBack()
  topContainer.paddingBottom = 15
  topContainer.width = am4core.percent(100)

  var title = topContainer.createChild(am4core.Label)
  title.text =
    '[font-size: 1.75rem font-weight: 500 line-height:1.2]' +
    titleString +
    '[/]'
  // if (Object.keys(this.filters).includes('question')) {
  //   title.text += ' (' + this.getLabelForSelectedOption('question') + ')'
  // }
  title.align = 'left'
  title.width = am4core.percent(100)
  title.wrap = true

  if (xAxis) {
    chart.legend = new am4charts.Legend()
    var markerTemplate = chart.legend.markers.template
    markerTemplate.width = 15
    markerTemplate.height = 15
  }

  return [chart, title]
}
